export enum Application {
    quoteAssist = 'quote-assist',
    ventilationPlanner = 'ventilation-planner',
    pvPlanner = 'pv-planner',
    vitoairProSelect = 'vitoairpro-select',
    a2aPlanner = 'a2a-planner',
}
